import { createAction } from 'redux-actions';

import {
  RECAPTCHA_EXECUTE,
  RECAPTCHA_SET_TOKEN,
  RECAPTCHA_SKIP,
  RECAPTCHA_TOKEN_EXPIRED,
} from '../constants';

export const showRecaptchaChallenge = createAction(RECAPTCHA_EXECUTE);

export const skipRecaptcha = createAction(RECAPTCHA_SKIP);

export const setRecaptchaToken = createAction(RECAPTCHA_SET_TOKEN, token => ({ token }));

export const setRecaptchaTokenExpired = createAction(RECAPTCHA_TOKEN_EXPIRED);
